import { Component } from '@angular/core';
import {FirebaseService} from './firebase.service';
import { MatMenuPanel } from '@angular/material/menu';

@Component({
  selector: 'app-signin-button',
  templateUrl: './signin-button.component.html',
  styles: []
})
export class SigninButtonComponent {
  menu: MatMenuPanel;

  constructor(public service: FirebaseService) { }
}
